import { useWorkspaceMeta } from 'main/services/api/data-providers/workspace'

export const useHasTemplatesAwaitingReview = () => {
  const meta = useWorkspaceMeta()

  return meta.runbooksMetaFull?.template_action_required
}
